import { render, staticRenderFns } from "./ProfessionalAgendaConfig.vue?vue&type=template&id=6a94852a&scoped=true"
import script from "./ProfessionalAgendaConfig.vue?vue&type=script&lang=js"
export * from "./ProfessionalAgendaConfig.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalAgendaConfig.vue?vue&type=style&index=0&id=6a94852a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a94852a",
  null
  
)

export default component.exports